<template>
  <div>
    <v-btn elevation="0" color="primary" outlined fab small dark @click="displayCropImageDialog">
      <v-icon>mdi-image</v-icon>
    </v-btn>
    <v-dialog v-model="cropImageDialog" width="99%" style="margin-top:20px;">
      <v-card style="overflow-x:hidden" class="text-center pa-2">
        <v-card-text>
          <div v-if="imageLoaded" class="mb-1 text-subtitle-1">{{ $t('message.drag_pinch_to_move') }}</div>
          <croppa v-model="myCroppa" :width="300" :height="300" :disable-rotation="false"
            @file-choose="handleCroppaFileChoose" style="width:300px;height:300px;"
            :placeholder="$t('message.click_to_pick_image')">
          </croppa>
        </v-card-text>
        <v-progress-linear v-if="uploading" indeterminate color="secondary"></v-progress-linear>
        <v-card-actions>
          <v-btn elevation="0" fab small @click="rotate(90)" color="primary" outlined
            :disabled="!imageLoaded || uploading">
            <v-icon>mdi-format-rotate-90</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="0" fab small @click="uploadCroppedImage()" color="success"
            :disabled="!imageLoaded || uploading">
            <v-icon>mdi-cloud-upload-outline</v-icon>
          </v-btn>
          <v-btn elevation="0" fab small @click="closeDialog()" color="error">
            <v-icon>mdi-close-box-outline</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api2";

export default {
  components: {
  },
  data() {
    return {
      image: null,
      imageLoaded: false,
      myCroppa: null,
      cropImageDialog: false,
      uploadingMessage: null,
      uploadedFileName: null,
      uploadedFileType: null,
      resize: false,
      callWhenDone: null,
      uploading: false,
      onUploadProgress: function () { }
    };
  },
  props: ["successFunction", "objId", "operation", "vm", "enableResize", "addSmall"],
  watch: {},
  created() {
    this.callWhenDone = this.successFunction;
    if (this.enableResize)
      this.resize = this.enableResize;
  },
  methods: {
    uploadCroppedImage() {
      this.myCroppa.generateBlob(
        blob => {
          this.uploading = true;
          this.uploadImage(blob);
        },
        'image/jpeg',
        0.9,
      ); // 80% compressed jpeg file
    },
    handleCroppaFileChoose(event) {
      this.imageLoaded = true;
      this.uploadedFileType = event.type;
      this.uploadedFileName = event.name;
    },
    onImageChange() {

    },
    closeDialog() {
      this.cropImageDialog = false;
      this.myCroppa.remove();
      this.imageLoaded = false;
    },
    rotate() {
      this.myCroppa.rotate(-1);
    },


    getCroppieViewport() {
      if (this.$vuetify.breakpoint.name == 'xs' ||
        this.$vuetify.breakpoint.name == 'sm') {
        this.croppieViewport = { width: 200, height: 200, type: 'square' };
        this.croppieViewport = { width: 250, height: 250 };
      }
    },
    displayCropImageDialog() {
      this.cropImageDialog = !this.cropImageDialog;
    },
    async uploadImage(blob) {
      //PUSH
      try {
        const vm = this;
        const d = new Date();
        const formData = new FormData();
        this.uploadingMessage = this.$t('message.image_upload_progress');
        const millis = d.getTime();
        const imgExtension = this.uploadedFileType.toLowerCase().split('/')[1];
        formData.append("image", blob, 'bjjlink-user-cropped-uploaded-image-' + millis + '.' + imgExtension);
        Api().post("content/img/cropped", formData, {//Cropped always creates a small version
          onUploadProgress: (uploadEvent) => {
            vm.onUploadProgress(uploadEvent);
          },
        }).then((res) => {
          //allow a small delay while the image processes
          setTimeout(function () {
            vm.uploading = false;
            vm.callWhenDone(res.data, vm.vm);
            vm.closeDialog();
          }, 4000);
        });
      } catch (err) {
        console.log('WTF?????', err);
        this.showAlert('error', this.$t('message.oops_not_working'));
      }
    }
  }
};
</script>

<style scoped></style>